import React from "react";
import { generateHTML } from "@tiptap/html";
import i18n from "i18next";
// import { Text } from "@tiptap/extension-text";
import {
  StarterKit,
  Highlight,
  // CharacterCount,
  Underline,
  Placeholder,
  // Emoji,
  TextAlign,
  TextStyle,
  FontFamily,
  Typography,
  // Color,
  // Dropcursor,
  // CollaborationCursor,
  Subscript,
  // TableOfContents,
  Superscript,
  CodeBlock,
  // BulletList,
  // OrderedList,
  // Collaboration,
  // TaskItem,
  // TaskList,
  // FileHandler,
  // Selection,
  // Focus,
  Table,
  HorizontalRule,
  Heading,
  Document,
  // TrailingNode,
  // FontSize,
  // Figure,
  // Figcaption,
  BlockquoteFigure,
  // Quote,
  // QuoteCaption,
  Link,
  // ImageUpload,
  //   ImageBlock,
  //   VideoBlock,
  // AudioBlock,
  // Youtube,
  // Instagram,
  // Columns,
  Paragraph,
  // InsideLinks,
  TableCell,
  TableHeader,
  TableRow,
  Column,
  LinkPreview,
  //   Twitter,
  // Linkedin,
  // Tiktok,
  // Facebook,
  //   Instagram,
  //   Youtube,
} from "../index.js";

import { TwitterBlockServerside } from "./TwitterBlockServerside.js";
import { YouTubeServerside } from "./YouTubeServerside.js";
import { InstagramServerside } from "./InstagramServerside.js";
import { ImageBlockServerside } from "./ImageBlockServerside.js";
import { TiktokServerside } from "./TiktokServerside.js";
import { LinkedinServerside } from "./LinkedinServerside.js";
import { FacebookServerside } from "./FacebookServerside.js";
import { VideoBlockServerside } from "./VideoBlockServerside.js";
import { InsideLinkServerside } from "./InsideLinkServerside.js";
import { IFrameServerside } from "./IFrameServerside.js";
import { AdditionalContextType } from "../../features/BlockEditor/types.js";
import { cn } from "../../lib/utils/index.js";

const DEFAULT_LANG = "en";

type Props = {
  body: any;
  additionalContext?: AdditionalContextType;
  containerClassName?: string;
};

// Initialize i18n based on additionalContext
const initializeI18n = (additionalContext?: AdditionalContextType) => {
  if (!additionalContext) {
    i18n.init({
      fallbackLng: DEFAULT_LANG,
      lng: DEFAULT_LANG,
      returnEmptyString: true,
      resources: {},
    });
    return;
  }

  if (additionalContext.language && additionalContext.translations) {
    i18n.init({
      fallbackLng: additionalContext.language,
      lng: additionalContext.language,
      returnEmptyString: true,
      resources: {
        [additionalContext.language]: {
          translation: additionalContext.translations,
        },
      },
    });
    return;
  }

  if (additionalContext.language) {
    i18n.init({
      fallbackLng: additionalContext?.language,
      lng: additionalContext?.language,
      returnEmptyString: true,
      resources: {},
    });
  }
};

export const ServersideTiptapBody = ({
  body,
  additionalContext,
  containerClassName,
}: Props) => {
  if (!body) return null;

  // Initialize i18n synchronously
  initializeI18n(additionalContext);

  const textDirection = additionalContext?.textDirection || i18n.dir();

  return (
    <>
      <div
        className={cn("tiptap ProseMirror min-h-full", containerClassName)}
        dir={textDirection}
        dangerouslySetInnerHTML={{
          __html: generateHTML(body, [
            // Text,
            StarterKit.configure({
              paragraph: false,
              document: false,
              dropcursor: false,
              heading: false,
              horizontalRule: false,
              blockquote: false,
              history: false,
              codeBlock: false,
            }),
            Highlight,
            // CharacterCount,
            Underline,
            Placeholder,
            // Emoji,
            TextAlign,
            TextStyle,
            FontFamily,
            Typography,
            // Color,
            // Dropcursor,
            // CollaborationCursor,
            // Subscript,
            // TableOfContents,
            // Superscript,
            CodeBlock,
            // BulletList,
            // OrderedList,
            // Collaboration,
            // TaskItem,
            // TaskList,
            // FileHandler,
            // Selection,
            // Focus,
            Table,
            HorizontalRule,
            Heading,
            Document,
            // TrailingNode,
            // SlashCommand,
            // FontSize,
            // Figure,
            // Figcaption,
            BlockquoteFigure,
            // Quote,
            // QuoteCaption,
            ImageBlockServerside,
            VideoBlockServerside,
            // AudioBlock,
            // Columns,
            TwitterBlockServerside,
            InstagramServerside,
            YouTubeServerside,
            Paragraph,
            Superscript,
            Subscript,
            Link,
            TiktokServerside,
            LinkedinServerside,
            FacebookServerside,
            InsideLinkServerside,
            IFrameServerside,
            // InsideLinks,
            TableCell,
            TableHeader,
            TableRow,
            Column,
            LinkPreview,
          ]),
        }}
      />
    </>
  );
};
